import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { UpdateIsShopify } from "../../actions";
import { useDispatch } from "react-redux";
import { AppRoutes } from "../routes/route.path";
import { ShopifyService } from "../../services/channels/ShopifyService";
import { AuthService } from "../../services/AuthService";
import Config from "../../config";
import createApp from "@shopify/app-bridge";
import { Redirect } from "@shopify/app-bridge/actions";

const ShopifyAuthenticationCallBackComponent = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(location.search);
    const shop = params.get("shop");
    const code = params.get("code");
    const host = params.get("host");

    const apiKey = Config.SHOPIFY_KEY;

    const ensureAppBridgeContext = () => {
        if (window.top === window.self) {
            // App is outside Shopify Admin, redirect to embedded version
            const app = createApp({
                apiKey,
                host,
                forceRedirect: true,
            });
            Redirect.create(app).dispatch(
                Redirect.Action.REMOTE,
                `${AppRoutes.SHOPIFY}?shop=${shop}&host=${host}`
            );
        }
    };

    useEffect(() => {
        if (shop) {
            ShopifyService.RetrieveShopifyAcessToken(shop).then((res) => {
                if (res?.data?.token) {
                    const app = createApp({
                        apiKey,
                        host,
                        forceRedirect: true,
                    });
                    UpdateIsShopify(dispatch, {
                        shop,
                        shopify: true,
                        access_token: res.data.token,
                    });
                    navigate(
                        AuthService.isUserLoggedIn()
                            ? AppRoutes.CHANNELS
                            : AppRoutes.CHANNELS_SIGN_IN
                    );
                }

                else {
                    // Retrieve and store the access token
                    ShopifyService.GetAccessToken({ shop, code })
                        .then((res) => {
                            const accessToken = res.data.access_token;

                            // Store the token in the backend
                            ShopifyService.StoreShopifyAcessToken({ shop_id: shop, token: accessToken });

                            // Update Redux state
                            UpdateIsShopify(dispatch, {
                                shop,
                                shopify: true,
                                access_token: accessToken,
                            });

                            navigate(
                                AuthService.isUserLoggedIn()
                                    ? AppRoutes.CHANNELS
                                    : AppRoutes.CHANNELS_SIGN_IN
                            );
                        })
                }
            })
        }
    }, [shop, code, dispatch, navigate]);

    // Ensure the app runs inside the App Bridge context
    useEffect(() => {
        ensureAppBridgeContext();
    }, [host, shop]);

    return (
        <div className="w-p-100 h-p-100 d-flex justify-center align-center h4-semibold">
            Authenticating with Shopify...
        </div>
    );
};

export default ShopifyAuthenticationCallBackComponent;
